"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

require("./Button.scss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Button = function Button(_ref) {
  var backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      clickHandler = _ref.clickHandler,
      onClick = _ref.onClick,
      customClassName = _ref.customClassName,
      text = _ref.text,
      textColor = _ref.textColor,
      type = _ref.type,
      styleType = _ref.styleType,
      disabled = _ref.disabled,
      children = _ref.children;
  var buttonText = text;

  if (!text && children) {
    buttonText = children;
  }

  var buttonClick = clickHandler || onClick;
  var buttonStyleType = type;

  if (styleType) {
    buttonStyleType = styleType;
  }

  var className = 'custom-button';
  var style = {};

  switch (buttonStyleType) {
    case 'success':
      className += ' syn-button-success';
      break;

    case 'error':
      className += ' syn-button-error';
      break;

    case 'default2':
      className += ' syn-button-default2';
      break;

    default:
      if (!backgroundColor) className += ' default-background-color';else style['backgroundColor'] = backgroundColor;
      if (!textColor) className += ' default-text-color';else style['color'] = textColor;
      if (!borderColor) className += ' default-border-color';else style['border'] = "1px solid ".concat(borderColor);
      break;
  }

  if (disabled) className += ' custom-button-disabled';
  if (customClassName) className += " ".concat(customClassName);
  return /*#__PURE__*/_react["default"].createElement("button", {
    onClick: buttonClick,
    className: className,
    type: styleType && type ? type : null,
    style: style,
    disabled: disabled
  }, buttonText);
};

var _default = Button;
exports["default"] = _default;
Button.propTypes = {
  filledIn: _propTypes.bool,
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  clickHandler: _propTypes.func
};